import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5c26c380"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "category-list"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "分类", -1);
});

var _hoisted_3 = {
  class: "container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_kila_kila_header = _resolveComponent("kila-kila-header");

  var _component_kila_kila_wife_cover = _resolveComponent("kila-kila-wife-cover");

  var _component_kila_kila_side_bar = _resolveComponent("kila-kila-side-bar");

  var _component_kila_kila_word_cloud_card = _resolveComponent("kila-kila-word-cloud-card");

  var _component_kila_kila_footer = _resolveComponent("kila-kila-footer");

  var _component_kila_kila_back_to_top = _resolveComponent("kila-kila-back-to-top");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_kila_kila_header), _createVNode(_component_kila_kila_wife_cover, null, {
    default: _withCtx(function () {
      return [_hoisted_2];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_kila_kila_side_bar), _createVNode(_component_kila_kila_word_cloud_card, {
    words: $setup.categoryCounts,
    baseUrl: "/category"
  }, null, 8, ["words"])]), _createVNode(_component_kila_kila_footer), _createVNode(_component_kila_kila_back_to_top)]);
}